import store from '../store';

let setState = obj => {
  store.dispatch('setState', obj);
};

export default setState;
